<template>
  <div>
    <v-card v-if="testator.requestedACall">
      <v-card-title> Testator requested a call </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <p v-if="testator.cellNumber">
              Contact number: {{ testator.cellNumber }}
            </p>
            <p v-else>
              Testator has not entered their phone number on step 1 yet
            </p>
            <v-btn
              :loading="buttonLoading"
              rounded
              depressed
              large
              color="primary"
              @click="updateTestator()"
            >
              Close call request
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <ErrorSnackbar v-model="showError" />
    <SuccessSnackbar v-model="showSuccess" :message="successMessage" />
  </div>
</template>

<script>
  import SuccessSnackbar from '../../common/SuccessSnackbar.vue';
  import ErrorSnackbar from '../../common/ErrorSnackbar.vue';
  import { formHelperMixin } from '../../../mixins/form-helper-mixin';
  import {
    UPDATE_TESTATOR_MUTATION,
    TESTATOR_QUERY,
  } from '../../../constants/graphql/testators';

  export default {
    name: 'RequestACallCard',
    components: {
      ErrorSnackbar,
      SuccessSnackbar,
    },
    mixins: [formHelperMixin],
    props: {
      testator: {
        required: true,
        type: Object,
      },
    },
    data() {
      return {
        showSuccess: false,
        successMessage: null,
      };
    },
    methods: {
      updateTestator() {
        this.buttonLoading = true;
        const testatorInputDetails = { requestedACall: false };
        const id = this.testator.id;

        this.$apollo
          .mutate({
            mutation: UPDATE_TESTATOR_MUTATION,
            variables: {
              id,
              testatorInputDetails,
            },
            update: (cache, { data: { updateTestator } }) => {
              this.updateCacheAfterUpdateTestator(cache);
            },
          })
          .then(data => {
            this.successMessage = 'Request a call successfully closed';
            this.showSuccess = true;
            this.buttonLoading = false;
          })
          .catch(error => {
            this.displayError();
            throw error;
          });
      },
      updateCacheAfterUpdateTestator(cache) {
        const query = {
          query: TESTATOR_QUERY,
          variables: { id: this.testator.id },
        };
        const data = cache.readQuery(query);

        data.testator.requestedACall = false;

        cache.writeQuery({ ...query, data: data });
      },
    },
  };
</script>
